import HTTP from "../../http";

const CART_ENDPOINT = "/carts";
const GET_CART_ENDPOINT = "/";

export async function getCart(cartId) {
  return await HTTP.get(CART_ENDPOINT + GET_CART_ENDPOINT + cartId, {
    headers: { "Content-Type": "application/json" }
  });
}
